import { buildLeadFormTrackingMetadata } from './widgetLeadFormSubmit.js'

/**
 * POST verified order lookup (ochatbot-v2 public widget route).
 *
 * @param {{
 *   apiBaseUrl?: string
 *   conf?: Record<string, unknown>
 *   orderNumber: string
 *   verificationType: 'email' | 'phone' | 'shipping_zip'
 *   verificationValue: string
 * }} params
 * @returns {Promise<{ ok: boolean, found: boolean, messageHtml: string, buttons: unknown[] }>}
 */
export async function postWidgetOrderStatusLookup(params) {
  const conf = params.conf || {}
  const base = String(params.apiBaseUrl || conf.apiBaseUrl || '').replace(/\/$/, '')
  const path = String(conf.orderStatus?.lookupUrl || '/api/v1/widget/order-status/lookup')
  const url = path.startsWith('http') ? path : `${base}${path.startsWith('/') ? path : `/${path}`}`

  const masterKey = String(conf.masterKey || '')
  const agentId = conf.agentId ?? conf.chatId
  if (!url || !masterKey || agentId == null || agentId === '') {
    throw new Error('Missing widget API base URL, master key, or agent id for order lookup.')
  }

  // Server logs lookups for the Form Responses report; include the same
  // tracking metadata the lead-form overlay sends.
  const tracking = buildLeadFormTrackingMetadata({ conf })

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'X-Master-Key': masterKey,
    },
    credentials: 'omit',
    body: JSON.stringify({
      agentId,
      orderNumber: params.orderNumber,
      verificationType: params.verificationType,
      verificationValue: params.verificationValue,
      user_id: tracking.user_id || undefined,
      page_url: tracking.page_url || undefined,
      user_agent: tracking.user_agent || undefined,
    }),
  })

  const text = await res.text().catch(() => '')
  let json = null
  try {
    json = text ? JSON.parse(text) : null
  } catch {
    json = null
  }

  if (!res.ok) {
    const msg =
      (json && typeof json === 'object' && json.error && String(json.error)) ||
      text ||
      res.statusText ||
      'Order lookup failed'
    throw new Error(`${msg} (${res.status})`)
  }

  if (!json || typeof json !== 'object') {
    throw new Error('Invalid response from order lookup.')
  }

  return {
    ok: Boolean(json.ok),
    found: Boolean(json.found),
    messageHtml: String(json.messageHtml || ''),
    buttons: Array.isArray(json.buttons) ? json.buttons : [],
  }
}
